import { useCallback } from 'react'

import { useChatChannelConfig } from '@liveHelper/context/ChatChannelConfigContext'
import { useShowWelcomeMessage } from '@liveHelper/hooks/useShowWelcomeMessage'
import { actionsSelector, useStore } from '@liveHelper/models/store'
import { useTrackConversationAction } from '@liveHelper/tracking/useLiveHelperTracking'

interface ReturnProps {
  onEndConversationConversationAction: () => void
  onJoinQueueConversationAction: () => void
}

/**
 * Hook that returns conversation actions
 */
export const useConversationAction = (): ReturnProps => {
  const { removeLastChatActions } = useStore(actionsSelector)
  const chatChannelConfig = useChatChannelConfig()
  const trackConversationAction = useTrackConversationAction()
  const showWelcomeMessage = useShowWelcomeMessage()

  const onEndConversation = useCallback(() => {
    removeLastChatActions()
    trackConversationAction({
      type: 'post_sales_classification_question',
      action: 'end_conversation',
      content: `Yes, I'm all set`,
    })
  }, [removeLastChatActions, trackConversationAction])

  const onJoinQueue = useCallback(() => {
    removeLastChatActions()
    if (!chatChannelConfig?.feature_flags?.include_system_messages) {
      showWelcomeMessage()
    }
    trackConversationAction({
      type: 'post_sales_classification_question',
      action: 'join_queue',
      content: `I have a new order question`,
    })
  }, [
    chatChannelConfig?.feature_flags?.include_system_messages,
    removeLastChatActions,
    showWelcomeMessage,
    trackConversationAction,
  ])

  return {
    onEndConversationConversationAction: onEndConversation,
    onJoinQueueConversationAction: onJoinQueue,
  }
}
